import {reactivateUserManagementUser} from "@project/sdk/user-management";
import {
  ReactivateUserManagementUserHeader,
  ReactivateUserManagementUserResponse,
} from "@project/sdk/user-management/zod";
import {mutationOptions} from "@tanstack/react-query";
import {
  userManagementUserKeys,
  userManagementUserMutationKeys,
} from "../../../userManagementUser-keys";

export function reactivateUserManagementUserMutationOptions() {
  return mutationOptions({
    mutationKey: userManagementUserMutationKeys.reactivateUserManagementUser,
    mutationFn: async ({userId, idempotencyKey}: {userId: string; idempotencyKey: string}) =>
      ReactivateUserManagementUserResponse.parse(
        await reactivateUserManagementUser(userId, {
          headers: ReactivateUserManagementUserHeader.parse({"Idempotency-Key": idempotencyKey}),
        }),
      ),
    onSuccess: async (_data, {userId}, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: userManagementUserKeys.detail(userId)}),
        client.invalidateQueries({queryKey: userManagementUserKeys.lists()}),
      ]);
    },
  });
}
